/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import Modal from '../../containers/modal.jsx';

import styles from './MyProjects.css'
import Filter from '../filter/filter.jsx';
import classNames from 'classnames';
import Divider from '../divider/divider.jsx';
import { connect } from 'react-redux';
import { getIsShowingWithoutId, loadMayuanProject, setProjectId } from '../../reducers/project-state.js';
import { ProjectApi } from '../../api/project.js';
import ButtonComponent from '../button/button.jsx';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { openQrCode, setInfo } from '../../reducers/modals.js';

// import defaultCover from './defaultCover.png'

//防抖函数
function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

function MyProjects(props) {
    const coverHost = 'https://scratch-1256154465.cos.ap-shanghai.myqcloud.com/static/cover/';
    const [data, setData] = useState([])
    const [mayuanID, setMayuanID] = useState('')
    const [filterQuery, setFilterQuery] = useState('')
    const debouncedFilterQuery = useDebounce(filterQuery, 1000);
    useEffect(() => {
        ProjectApi.getMyProjectList({ userID: props.userID, projectTitle: filterQuery }).then((data) => {
            console.log(data)
            setData(data.scratchProjects)
        })
    }, [props.userID, debouncedFilterQuery])

    const handleClickProjectItem = (projectID) => {
        if (props.shouldOpenNewTab) {
            window.open(`./#${projectID}`)
        } else {
            props.setProjectID(projectID)
            props.handleClose()
        }
    }


    const handleFilterChange = (e) => {
        setFilterQuery(e.target.value)
    }

    const openQRCode = () => {
        props.openQRCode()
    }

    const deleteProject = (projectID) => {
        if (props.currentProjectID == projectID) {
            alert("不能删除当前打开的作品")
        } else {
            if (window.confirm("确定删除作品吗？")) {
                ProjectApi.deleteProject(projectID).then((data) => {
                    console.log(data)
                    setData((prevData) => {
                        return prevData.filter((item) => item.id !== projectID)
                    })
                })
            }
        }
    }

    return (
        <div>
            <Modal
                fullScreen
                contentLabel={"我的作品库"}
                id={"myProjects"}
                onRequestClose={props.handleClose}
            >
                <div className={classNames(styles.filterBar, styles.filterHeight)}>
                    <Filter
                        className={classNames(
                            styles.filterBarItem,
                            styles.filter,
                        )}
                        filterQuery={filterQuery}
                        // inputClassName={styles.filterInput}
                        placeholderText={"搜索作品名称"}
                        onChange={(e) => handleFilterChange(e)}
                    // onClear={this.handleFilterClear}
                    />
                    <Divider className={classNames(styles.filterBarItem, styles.divider, styles.dividerHeight)} />
                    <Filter
                        className={classNames(
                            styles.filterBarItem,
                            styles.filter,
                        )}
                        // filterQuery={this.state.filterQuery}
                        // inputClassName={styles.filterInput}
                        placeholderText={"输入码猿平台作品ID"}
                        onChange={(e) => {

                            setMayuanID(e.target.value)
                        }}
                    />
                    <ButtonComponent
                        onClick={() => {
                            console.log('输入码猿平台作品ID ', mayuanID)
                            ProjectApi.getMayuanProject({ mayuanID: mayuanID }).then((projectData) => {
                                console.log(projectData)
                                props.loadMayuanProject(projectData)
                                props.handleClose()

                            })
                            // .then((data) => {
                            //     console.log(data)
                            //     props.loadMayuanProject(data)
                            //     props.handleClose()
                            // })
                        }}
                    >点击打开(会关闭当前作品,小心丢失作品)</ButtonComponent>
                </div>
                <div className={classNames(styles.libraryScrollGrid, styles.withFilterBar)}>
                    {data.map((item) => {
                        {/* {
                            "id": 1,
                            "title": "Hello World",
                            "user_id": "zhouwei",
                            "uuid": "550e8400-e29b-41d4-a716-446655440000",
                            "defunct": "N",
                            "cover": "",
                            "hits": 0,
                            "likes": 0,
                            "published": 0,
                            "open_source": 0,
                            "created_at": "2023-10-13T17:32:49+08:00",
                            "updated_at": "2023-10-13T17:32:56+08:00",
                            "original_id": 0
                        } */}
                        return (
                            <div
                                key={item.id}
                                className={classNames(styles.libraryItem, styles.featuredItem, styles.projectItem)}
                            >
                                <div className={classNames(styles.featuredImageContainer, styles.imageContainer)}
                                    onClick={() => { handleClickProjectItem(item.id) }}
                                >
                                    {/* <img
                                        className={styles.featuredImage}
                                        src={item.cover && item.cover.length > 0 ? item.cover : `${coverHost}${item.id}.png`}
                                    /> */}
                                    <LazyLoadImage
                                        className={styles.featuredImage}
                                        src={item.cover && item.cover.length > 0 ? item.cover : `${coverHost}${item.id}.png`}
                                    ></LazyLoadImage>
                                </div>
                                <div
                                    className={classNames(styles.featuredExtensionText, styles.featuredText, styles.titleContainer)}
                                >
                                    <span className={styles.libraryItemName}>
                                        {item.title}
                                    </span>
                                    <br />
                                    <div className={classNames(styles.featuredDescription, styles.oneLineText)}>
                                        {new Date(item.created_at).toLocaleString()}
                                    </div>
                                    <div className={styles.iconContainer}>
                                        <span className={styles.svgIcon} onClick={() => {
                                            deleteProject(item.id)
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>delete-outline</title><path d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z" /></svg>
                                        </span>
                                        {/* 目标url格式 https://ipachong.com/scratch-player3/player.html?uuid=0c6e8039-af1b-4b7d-ab48-363a47e879f7 */}
                                        <span className={styles.svgIcon} onClick={() => {
                                            props.setInfo({ QRCodeUrl: `https://ipachong.com/scratch-player3/player.html?uuid=${item.uuid}&inphone=1#1` });
                                            openQRCode();
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>qrcode</title><path d="M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z" /></svg>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Modal>
        </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    const loadingState = state.scratchGui.projectState.loadingState;
    // console.log(loadingState, state.session)
    const user = state.session && state.session.session && state.session.session.user;
    //                             是新项目并且没更改
    const shouldOpenNewTab = state.scratchGui.projectChanged
    return {
        loadingState: loadingState,
        userID: user ? user.userID : null,
        shouldOpenNewTab: shouldOpenNewTab, //是否应该新窗口中打开
        currentProjectID: state.scratchGui.projectState.projectId,
    };
};
const mapDispatchToProps = dispatch => ({
    // setSession: (session) => dispatch(setSession(session))
    setProjectID: (projectID) => dispatch(setProjectId(projectID)),
    loadMayuanProject: (projectData) => dispatch(loadMayuanProject(projectData)),
    setInfo: (info) => dispatch(setInfo(info)),
    openQRCode: () => dispatch(openQrCode()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyProjects);

